import { useEffect, useId } from "react";
import { removeDeckLayer, upsertDeckLayer } from "src/js/stores/map/actions/updateDeckSettings";
import type { DeckLayer } from "src/js/stores/map/store";

type CreateLayerFn = () => Omit<DeckLayer, "key">;

export function useMapLayer(createLayer: CreateLayerFn, deps: unknown[]) {
  const key = useId();

  useEffect(() => {
    upsertDeckLayer({ ...createLayer(), key });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    return () => removeDeckLayer(key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
